import { atom } from 'recoil';
import { FilterDef } from '../../../constants/FinanceModels';

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'livemonitoring-state-active-filters',
    default: []
});